/* eslint-disable @typescript-eslint/strict-boolean-expressions */
// istanbul ignore file
import React, { useState, useEffect } from 'react'
import './dashboard.css'
import { MemoHealthSummaryCard } from './healthSummaryCard'
import {
  CircularProgress,
  Grid,
  Drawer,
  styled,
  Breadcrumbs,
  Typography,
  Box,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  TextField,
  Button as CustomButton,
  Checkbox,
  FormControlLabel
} from '@mui/material'
import {
  getHealthSummaryService,
  getSaveDeafaultWidget,
  getAlertsNotificationDataByFilter,
  saveDefaultViewDataservice,
  getDeviceStatusRegisterSummaryService,
  getDeviceStatusKPISummaryService,
  getDeviceStatusOnlineService,
  getAlertTrendKPIDataDeviceDashboardService,
  getAlertTrendRegisterDataDeviceDashboardService,
  fetchflameSignalDataNEWONE,
  fetchflameKPISignalData,
  fetchflowParamSignalData,
  fetchflowKPISignalData
} from '../../device-dashboard/redux/actionCreator'
import { type GetDefaultWidgetDataState } from '../../device-dashboard/redux/getSaveDefaultViewServiceSlice'
import { type SaveDefaultViewDataState } from '../redux/saveDefaultViewSlice'
import { type SaveDefaultViewRequest } from '../services/saveDeafultViewService'
import { GenXDropdown, type Option } from '../../../components/GenXDropdown'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { type RootState } from '../../../store'
import AuthError from '../../../components/ErrorComponents/AuthError'
import lowBadge from '../../../assets/lowBadge.svg'
import highBadge from '../../../assets/highBadge.svg'
import mediumBadge from '../../../assets/mediumBadge.svg'
import FlameSignalGraph from './flameSignalGraph'
import FuelFlowGraph from './fuelFlowGraph'
import notificationIcon from '../../../assets/Notification-Icon.png'
import AlertNotification from '../../asset-dashboard/components/alertNotification'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { Button } from '../../../components/Button'
import dayjs from 'dayjs'
import breadcrumimg from '../../../assets/site-img.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import Link from '@mui/material/Link'
import DeviceStatusCard from './deviceStatusCard'
import { type MenuInfoState } from './../../dashboard/redux/menuInfoSlice'
import { useDispatch } from 'react-redux'
import EditIcon from '../../../assets/Edit.svg'
import ApexCharts from 'react-apexcharts'
import { SaveDefaultViewObjectUpdateAction } from '../redux/saveDefaultViewObjectSlice'
import ModelPopup from '../../../components/Modal'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import refresh from '../../../assets/refresh.svg'
import { updateSaveDefaultObject } from '../../../utils/updateSaveDefaultObject'
import { type AlertTrendKPIDeviceDataState } from '../../device-dashboard/redux/getAlertTredKPIDataDeviceDashboardSlice'
import { type AlertTrendRegisterDataDeviceState } from '../../device-dashboard/redux/getAlertTredRegisterDataSlice'
// import { type DeviceStatusOnlineDataState } from '../../device-dashboard/redux/getDeviceStatusOnlineSlice'
import moment from 'moment-timezone'
import { fetchParameterTree } from '../../asset-dashboard/redux/actionCreator'
import { type ParameterTreeState } from '../../asset-dashboard/redux/parameterTreeSlice'
import { getOperationPermissions } from '../../dashboard/redux/actionCreator'
import { type OperationPermissionState } from '../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'
import CustomToast from '../../device-management/components/ToastComponent'
import useRefreshHamburgNotifier from '../../../customHooks/useRefreshHamburgNotifier'
import { MemorizedBookmark } from '../../bookmarks-home/components/ToggleBookmarkComponent'
import { fetchParameterConfiguration } from '../../services/redux/ParameterConfigurationActionCreators'
import { DEFAULT_DATA_WINDOW_HOURS } from '../../../utils/DashboardContants'
import { MemoParametersList } from './ParametersList'
import { MemoDeviceStatus } from './DeviceStatus'

export interface StateLocation {
  parentSiteId: string
  parentAssetId: string
  parentDeviceTypeId: string
  deviceId: string
  siteName: string
  assetName: string
  deviceName: string
}

export const getStatusIcons = (status: string): JSX.Element => {
  switch (status) {
    case 'low':
      return <img src={lowBadge} />
    case 'medium':
      return <img src={mediumBadge} />
    case 'high':
      return <img src={highBadge} />
    default:
      return <img src={lowBadge} />
  }
}

const WhiteDatePicker = styled(DateTimePicker)({
  '& .MuiInputBase-input': {
    color: '#D0D0D0'
  },
  '& .MuiInputBase-root': {
    background: '#5c5b5bdd',
    height: '40px',
    overflow: 'unset',
    minWidth: '150px' // Corrected the width unit here
  },
  '& .MuiStack-root': {
    overflow: 'unset !important',
    '& .MuiTextField-root': {
      // Add your styles for .MuiTextField-root here
      backgroundColor: '#ffffff',
      minWidth: '100px', // Example style
      border: '1px solid #ccc' // Example style
    }
  },
  // Change icon color when disabled
  '& .Mui-disabled .MuiIconButton-root': {
    color: '#888888 !important' // Set your desired disabled color here
  }
})

const deviceDashboardMain = (props: PropsFromRedux): JSX.Element => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const [openFilter, setOpenFilter] = React.useState(false)
  const [saveDefaultView, setSaveDefaultView] = React.useState(false)
  const [startDate, setStartDate] = React.useState('')
  const [endDate, setEndDate] = React.useState('')
  const [endDateValue, setEndDateValue] = useState(null)
  const [startDateValue, setStartDateValue] = useState(null)
  const [startDateLocal, setStartDateLocal] = useState('')
  const [endDateLocal, setEndDateLocal] = useState('')
  const [range, setRange] = React.useState('hourly')
  const [golive, setGolive] = React.useState(false)
  const [isGolive, setIsGolive] = React.useState(false)
  const [combinedData, setCombinedData] = React.useState<any>([])
  const [alertTrendParameter, setAlertTrendParameter] = React.useState({
    timezone: userTimezone,
    status: 'Go live'
  })
  const [customeDateSelection, setCustomeDateSelection] = React.useState(false)
  // ...existing state variables...

  const GetSaveDefaultWidgetStatus = useSelector(
    (state: RootState) => state.saveDefaultWidgetData
  )
  const saveDefaultViewObject = useSelector(
    (state: RootState) => state.saveDefaultViewObject.saveDefaultViewObject
  )
  const AlertRegisterData: any = useSelector(
    (state: RootState) => state.alertTrendRegisterDeviceDashboard
  )
  const AlertKPIData: any = useSelector(
    (state: RootState) => state.alertTrendKPIDeviceDashboard
  )
  const operationPermissions: OperationPermissionState = useSelector(
    (state: RootState) => state.operationPermissions
  )

  const auth = useAuth()
  const SaveDefaultViewData = useSelector(
    (state: RootState) => state.SaveDefaultViewData
  )
  const { refreshHamburgAction } = useRefreshHamburgNotifier()

  const GetDeviceParameters = useSelector(
    (state: RootState) => state.getParameterConfigurationData
  )

  useEffect(() => {
    !operationPermissions.updated &&
      props.getOperationPermissions(auth.user?.profile.sub as string)
    props?.fetchParameterTree()
    setAlertTrendParameter({
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      status: 'Go live'
    })
  }, [])

  React.useEffect(() => {
    if (
      !(AlertRegisterData as AlertTrendRegisterDataDeviceState).isLoading &&
      !(AlertKPIData as AlertTrendKPIDeviceDataState).isLoading
    ) {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      const regData =
        AlertRegisterData.AlertTrendRegisterDataDeviceDashboard || []
      const kpiData = AlertKPIData.AlertTrendKPIDataDeviceDashboard || []
      setCombinedData([...regData, ...kpiData])
      const matchingRegisterIds = regData.map(
        (reading: any) => reading.paraMeterId
      )
      setSelectedRegisterIds(matchingRegisterIds)
      const matchingKpiIds = kpiData.map((kpi: any) => kpi.paraMeterId)
      setSelectedKpiIds(matchingKpiIds)
    }
  }, [AlertRegisterData, AlertKPIData])

  const [text, setText] = React.useState('Alert Trend')
  // const clearNotificationStatus = useSelector((state: RootState) => state.HealthSummaryState)
  const navigate = useNavigate()

  const stateLocation = useLocation()
  const [oldParentDeviceId, setOldParentDeviceId] = React.useState<any>(null) // For Re mounting when change asset
  const navigateState = stateLocation.state as StateLocation | null
  const parentDeviceId = navigateState != null ? navigateState.deviceId : ''
  const parentDeviceTypeId = navigateState != null ? navigateState.parentDeviceTypeId : ''
  const parentSiteId = navigateState != null ? navigateState.parentSiteId : ''
  const parentAssetId = navigateState != null ? navigateState.parentAssetId : ''
  const parentSiteName = navigateState != null ? navigateState.siteName : ''
  const parentAssetName = navigateState != null ? navigateState.assetName : ''
  const parentDeviceName = navigateState != null ? navigateState.deviceName : ''
  const [selectedDateRange, setSelectedDateRange] =
    React.useState<Option | null>(null)
  // const [getParametersData, setParametersData] = useState<any[]>([])
  // const [stdIndicators, setStdIndicators] = useState<any[]>([])
  // const [customIndicators, setCustomIndicators] = useState<any[]>([])
  // const [loaders, setLoaders] = useState(false)
  const [isEditing, setIsEditing] = React.useState(false)
  const [selectedRegisterIds, setSelectedRegisterIds] = useState<string[]>([])
  const [selectedKpiIds, setSelectedKpiIds] = useState<string[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [device, setDevice] = useState<any>(null)
  const [refreshRightPanel, setRefreshRightPanel] = useState<boolean>(false)
  const [isOpen, setIsOpen] = useState(false)
  const kpiObject = React.useRef<string | null>(null)
  const registerObject = React.useRef<string | null>(null)
  const dispatch = useDispatch()

  const maximumSelection = 4

  const getUtcDateRange = (): { today: string, defaultDataWindowUTC: string } => {
    const utcDate = dayjs()
    const today = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    const defaultDataWindowUTC = utcDate
      .utc()
      .subtract(DEFAULT_DATA_WINDOW_HOURS, 'hour')
      .format('YYYY-MM-DD HH:mm:ss')
    return { today, defaultDataWindowUTC }
  }

  const handleEditClick = (): void => {
    setIsEditing(true)
  }

  useEffect(() => {
    const { today, defaultDataWindowUTC } = getUtcDateRange()
    setSelectedDateRange(null)
    setStartDateValue(null)
    setEndDateValue(null)
    setStartDateLocal('')
    setEndDateLocal('')
    setStartDate('')
    setEndDate('')
    setAlertTrendParameter({
      timezone: userTimezone,
      status: 'Go live'
    })
    setIsGolive(true)
    const KPIObj = {
      deviceId: parentDeviceId,
      kpiDefinitionIds: [],
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }
    const registerObj = {
      deviceId: parentDeviceId,
      cimCodeIds: [],
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }
    refreshHamburgAction('Device', 'Update') // to refresh device parameter hierarchy
    // fetchKPIandParamData()
    props.callGetHealthSummaryService(
      parentSiteId,
      parentAssetId,
      parentDeviceId
    )
    props.getSaveDeafaultWidget(parentSiteId, parentAssetId, parentDeviceId)
    props.getAlertTrendKPIDataDeviceDashboardService(
      defaultDataWindowUTC,
      today,
      JSON.stringify(KPIObj),
      range,
      true,
      `${alertTrendParameter.timezone},${alertTrendParameter.status}`
    )
    props.getAlertTrendRegisterDataDeviceDashboardService(
      defaultDataWindowUTC,
      today,
      JSON.stringify(registerObj),
      range,
      true,
      `${alertTrendParameter.timezone},${alertTrendParameter.status}`
    )
    setOldParentDeviceId(parentDeviceId)
    return () => {
      // Cancel any ongoing API calls or cleanup tasks here
    }
  }, [parentDeviceId])

  useEffect(() => {
    props.getDeviceParameterService(parentSiteId, parentAssetId)
  }, [parentDeviceId, golive])

  const fetchKPIandParamData = (): void => {
    setRefreshRightPanel(!refreshRightPanel)
  }

  React.useEffect(() => {
    dispatch(SaveDefaultViewObjectUpdateAction(null))
  }, [parentDeviceId])

  const disableHourly = (): boolean => {
    const differenceInHours: number =
      (new Date(endDate).getTime() - new Date(startDate).getTime()) /
      (1000 * 60 * 60)
    return differenceInHours >= 25
  }

  const handleGoLiveView = (): void => {
    setAlertTrendParameter({
      timezone: userTimezone,
      status: 'Go live'
    })
    setSelectedDateRange(null)
    setCustomeDateSelection(false)
    const { today, defaultDataWindowUTC } = getUtcDateRange()
    setStartDateValue(null)
    setEndDateValue(null)
    setStartDateLocal('')
    setEndDateLocal('')
    localStorage.setItem('startDate', defaultDataWindowUTC)
    localStorage.setItem('endDate', today)
    const KPIObj = {
      deviceId: parentDeviceId,
      kpiDefinitionIds: selectedKpiIds,
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }
    setIsGolive(true)
    const registerObj = {
      deviceId: parentDeviceId,
      cimCodeIds: selectedRegisterIds,
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }
    setStartDate(defaultDataWindowUTC)
    setEndDate(today)
    setGolive((prevState) => !prevState) // Toggle the golive state to ensure re-render
    props.callGetHealthSummaryService(
      parentSiteId,
      parentAssetId,
      parentDeviceId
    )
    // fetchKPIandParamData()
    props.getSaveDeafaultWidget(parentSiteId, parentAssetId, parentDeviceId)
    props.getDeviceStatusKPISummaryService(
      parentSiteId,
      parentDeviceId,
      '',
      true
    )
    props.getDeviceStatusRegisterSummaryService(
      parentSiteId,
      parentDeviceId,
      '',
      true
    )
    props.getDeviceStatusOnlineService(parentDeviceId)

    if (range === 'daily' || range === 'weekly' || range === 'monthly') {
      const endDateLocal = dayjs()
      let startDateCus = ''
      const endDateCus = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')

      const getStartDate = (unit: dayjs.OpUnitType): string => {
        return endDateLocal.startOf(unit).utc().format('YYYY-MM-DD HH:mm:ss')
      }

      switch (range) {
        case 'daily':
          startDateCus = getStartDate('day')
          break

        case 'weekly':
          startDateCus = getStartDate('week')
          break

        case 'monthly':
          startDateCus = getStartDate('month')
          break
      }

      props.getAlertTrendKPIDataDeviceDashboardService(
        startDateCus,
        endDateCus,
        JSON.stringify(KPIObj),
        range,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.getAlertTrendRegisterDataDeviceDashboardService(
        startDateCus,
        endDateCus,
        JSON.stringify(registerObj),
        range,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
    } else {
      props.getAlertTrendKPIDataDeviceDashboardService(
        defaultDataWindowUTC,
        today,
        JSON.stringify(KPIObj),
        range,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.getAlertTrendRegisterDataDeviceDashboardService(
        defaultDataWindowUTC,
        today,
        JSON.stringify(registerObj),
        range,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
    }
  }

  React.useEffect(() => {
    const apiPayloadObj = {
      assetId: parentAssetId,
      deviceId: parentDeviceId,
      cimCodeIds: [],
      graphName: 'deviceGraph1',
      assetTypeId: parentDeviceTypeId
    }

    const apiPayloadKPI = {
      assetId: parentAssetId,
      deviceId: parentDeviceId,
      kpiDefinitionIds: [],
      graphName: 'deviceGraph1',
      assetTypeId: parentDeviceTypeId
    }

    const apiPayloadObjFlow = {
      assetId: parentAssetId,
      deviceId: parentDeviceId,
      cimCodeIds: [],
      graphName: 'deviceGraph2',
      assetTypeId: parentDeviceTypeId
    }

    const apiPayloadKPIFlow = {
      assetId: parentAssetId,
      deviceId: parentDeviceId,
      kpiDefinitionIds: [],
      graphName: 'deviceGraph2',
      assetTypeId: parentDeviceTypeId
    }

    const fetchData = (): void => {
      const { today, defaultDataWindowUTC } = getUtcDateRange()
      props.callGetHealthSummaryService(
        parentSiteId,
        parentAssetId,
        parentDeviceId
      )
      // fetchKPIandParamData()
      props.getSaveDeafaultWidget(parentSiteId, parentAssetId, parentDeviceId)
      props.getDeviceStatusRegisterSummaryService(
        parentSiteId,
        parentDeviceId,
        '',
        true
      )
      props.getDeviceStatusKPISummaryService(
        parentSiteId,
        parentDeviceId,
        '',
        true
      )
      props.getDeviceStatusOnlineService(parentDeviceId)
      const KPIObj = {
        deviceId: parentDeviceId,
        kpiDefinitionIds: selectedKpiIds,
        graphName: 'deviceAlertTrend',
        assetTypeId: parentDeviceTypeId
      }
      const registerObj = {
        deviceId: parentDeviceId,
        cimCodeIds: selectedRegisterIds,
        graphName: 'deviceAlertTrend',
        assetTypeId: parentDeviceTypeId
      }
      props.getAlertTrendKPIDataDeviceDashboardService(
        defaultDataWindowUTC,
        today,
        JSON.stringify(KPIObj),
        range,
        true,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.getAlertTrendRegisterDataDeviceDashboardService(
        defaultDataWindowUTC,
        today,
        JSON.stringify(registerObj),
        range,
        true,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.fetchflameSignalData_NEW(
        defaultDataWindowUTC,
        today,
        JSON.stringify(apiPayloadObj),
        true
      )
      props.fetchflameKPISignalData(
        defaultDataWindowUTC,
        today,
        JSON.stringify(apiPayloadKPI),
        true
      )
      props.fetchflowParamSignalData(
        defaultDataWindowUTC,
        today,
        JSON.stringify(apiPayloadObjFlow),
        true
      )
      props.fetchflowKPISignalData(
        defaultDataWindowUTC,
        today,
        JSON.stringify(apiPayloadKPIFlow),
        true
      )
    }
    if (!customeDateSelection) {
      const interval = setInterval(fetchData, 300000) // Fetch data every 5 minute
      // Initial fetch to set local storage values and fetch data
      return () => {
        clearInterval(interval)
      } // Cleanup on component unmount
    }
  }, [parentDeviceId, startDateLocal, endDateLocal, customeDateSelection]) // Run this effect once when the component mounts

  const selectedData = React.useRef<any>(null)

  React.useEffect(() => {
    if (saveDefaultViewObject !== null && saveDefaultViewObject !== undefined) {
      selectedData.current = findWidget(
        saveDefaultViewObject,
        'deviceAlertTrend'
      )
    }
  }, [saveDefaultViewObject])

  const findWidget = (obj: any, widgetID: string): any => {
    const { assetDashBoardDefaultView } = obj
    const match = assetDashBoardDefaultView.find(
      (widget: any) => widget.widgetId === widgetID
    )
    return match !== undefined ? match : null
  }

  const handleTextChange = (event: any): void => {
    setText(event.target.value)
    const newValue = event.target.value
    if (selectedData.current !== null) {
      selectedData.current = { ...selectedData.current, displayname: newValue }
    }
    updateTitleOnSaveDefaultObj(newValue, 'deviceAlertTrend')
  }

  const DataRangeOptions = [
    { label: 'Today', value: 'Today' },
    { label: 'Yesterday', value: 'Yesterday' },
    { label: 'This Hour', value: 'This Hour' },
    { label: 'Last Hour', value: 'Last Hour' },
    { label: 'Last 24 Hours', value: 'Last 24 Hours' },
    { label: 'This Week', value: 'This Week' },
    { label: 'Last Week', value: 'Last Week' },
    { label: 'This Month', value: 'This Month' },
    { label: 'Last Month', value: 'Last Month' }
  ]

  const defaultView = {
    assetDashBoardDefaultView: [
      {
        widgetId: 'deviceAlertTrend',
        displayname: 'Alert Trend',
        devices: [],
        assets: []
      },
      {
        widgetId: 'deviceGraph1',
        displayname: 'Graph1',
        devices: [],
        assets: []
      },
      {
        widgetId: 'deviceGraph2',
        displayname: 'Graph2',
        devices: [],
        assets: []
      },
      {
        widgetId: 'deviceStatus',
        displayname: 'deviceStatus card',
        devices: [],
        assets: []
      }
    ]
  }

  const handleDataRangeChange = (selectedDate: Option): void => {
    setStartDateValue(null)
    setEndDateValue(null)
    setIsGolive(false)
    setAlertTrendParameter({
      timezone: userTimezone,
      status: 'Go live'
    })
    setCustomeDateSelection(true)
    setSelectedDateRange(selectedDate)
    const endDateLocal = dayjs()
    let startDate = ''
    let endDate = endDateLocal.format('YYYY-MM-DD HH:mm:ss')

    const getStartDate = (
      unit: dayjs.OpUnitType,
      subtractValue = 0,
      startOfUnit = true
    ): string => {
      const date = subtractValue
        ? endDateLocal.subtract(subtractValue, unit as dayjs.ManipulateType)
        : endDateLocal
      return startOfUnit
        ? date.startOf(unit).utc().format('YYYY-MM-DD HH:mm:ss')
        : date.endOf(unit).utc().format('YYYY-MM-DD HH:mm:ss')
    }

    let defaultRange = 'hourly'

    const dateRanges: Record<string, () => void> = {
      Today: () => {
        startDate = getStartDate('day')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        setRange('hourly')
        defaultRange = 'hourly'
      },
      Yesterday: () => {
        startDate = getStartDate('day', 1)
        endDate = getStartDate('day', 1, false)
        setRange('hourly')
        defaultRange = 'hourly'
      },
      'This Hour': () => {
        startDate = getStartDate('hour')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        setRange('hourly')
        defaultRange = 'hourly'
      },
      'Last Hour': () => {
        startDate = getStartDate('hour', 1)
        endDate = getStartDate('hour', 1, false)
        setRange('hourly')
        defaultRange = 'hourly'
      },
      'Last 24 Hours': () => {
        startDate = getStartDate('hour', 24)
        endDate = getStartDate('hour', 0, false)
        setRange('hourly')
        defaultRange = 'hourly'
      },
      'This Week': () => {
        startDate = getStartDate('week')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        setRange('daily')
        defaultRange = 'daily'
      },
      'Last Week': () => {
        startDate = getStartDate('week', 1)
        endDate = getStartDate('week', 1, false)
        setRange('daily')
        defaultRange = 'daily'
      },
      'This Month': () => {
        startDate = getStartDate('month')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        setRange('daily')
        defaultRange = 'daily'
      },
      'Last Month': () => {
        startDate = getStartDate('month', 1)
        endDate = getStartDate('month', 1, false)
        setRange('daily')
        defaultRange = 'daily'
      }
    }

    if (dateRanges[selectedDate.value]) {
      dateRanges[selectedDate.value]()
    }

    setStartDate(startDate)
    setEndDate(endDate)

    const KPIObj = {
      deviceId: parentDeviceId,
      kpiDefinitionIds: selectedKpiIds,
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }

    const registerObj = {
      deviceId: parentDeviceId,
      cimCodeIds: selectedRegisterIds,
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }

    props.getAlertTrendKPIDataDeviceDashboardService(
      startDate,
      endDate,
      JSON.stringify(KPIObj),
      defaultRange,
      false,
      `${alertTrendParameter.timezone},${alertTrendParameter.status}`
    )
    props.getAlertTrendRegisterDataDeviceDashboardService(
      startDate,
      endDate,
      JSON.stringify(registerObj),
      defaultRange,
      false,
      `${alertTrendParameter.timezone},${alertTrendParameter.status}`
    )
  }

  const updateTitleOnSaveDefaultObj = (
    title: string,
    widgetID: string
  ): void => {
    const selectedDefaultData = {
      widgetId: widgetID,
      displayname: title,
      devices: [
        {
          deviceId: parentDeviceId,
          cimCodeIds: [],
          kpidefinitionIds: []
        }
      ],
      assets: []
    }
    updateSaveDefaultObject(
      saveDefaultViewObject,
      selectedData.current !== null
        ? selectedData.current
        : selectedDefaultData,
      widgetID
    )
  }

  const setDisplayname = (data: any, widgetId: string): void => {
    for (const widget of data.assetDashBoardDefaultView) {
      if (widget.widgetId === widgetId) {
        setText(widget.displayname)
        break
      }
    }
  }

  React.useEffect(() => {
    if (typeof props.saveDefaultWidgetData.DefaultWidgetData !== 'undefined') {
      setDisplayname(
        props.saveDefaultWidgetData.DefaultWidgetData,
        'deviceAlertTrend'
      )
    }
  }, [props.saveDefaultWidgetData])

  const handleOpenModalAlertTrend = (): void => {
    setIsOpen(true)
  }

  const handleCloseModal = (): void => {
    setIsOpen(false)
  }

  const handleBlur = (): void => {
    setIsEditing(false)
  }

  useEffect(() => {
    const findDevice = (data: any, id: string): any => {
      if (data.gateway !== undefined && Array.isArray(data.gateway)) {
        for (const gateway of data.gateway) {
          if (
            gateway.device !== undefined &&
                Array.isArray(gateway.device)
          ) {
            for (const device of gateway.device) {
              if (device.id === id) {
                return device
              }
            }
          }
        }
      }
      return null
    }
    if (!GetDeviceParameters.isLoading && GetDeviceParameters?.parameters !== undefined) {
      const foundDevice = findDevice(GetDeviceParameters?.parameters, parentDeviceId)
      setDevice(foundDevice)
    }
  }, [parentDeviceId, GetDeviceParameters?.parameters])

  useEffect(() => {
    if (SaveDefaultViewData.httpStatus === 201) {
      CustomToast({
        type: 'success',
        heading: 'Save Default View Success',
        message: 'Selected view saved successfully'
      })
    } else if (
      !SaveDefaultViewData.isLoading &&
      SaveDefaultViewData.loadingError !== undefined
    ) {
      console.log(
        SaveDefaultViewData,
        'SaveDefaultViewDataSaveDefaultViewData2'
      )
      CustomToast({
        type: 'error',
        heading: 'Save Default View Error',
        message: 'Thermal Asset not found'
      })
    }
  }, [SaveDefaultViewData])

  const handleCheckboxClick = (event: React.MouseEvent): void => {
    event.stopPropagation()
  }

  const handleChildCheckboxChange = (
    id: string,
    type: 'register' | 'kpi'
  ): void => {
    if (
      selectedRegisterIds.length + selectedKpiIds.length >= maximumSelection &&
      !selectedRegisterIds.includes(id) &&
      !selectedKpiIds.includes(id)
    ) {
      setIsModalOpen(true)
      return
    }

    if (type === 'register') {
      setSelectedRegisterIds((prevSelectedRegisterIds) => {
        if (prevSelectedRegisterIds.includes(id)) {
          return prevSelectedRegisterIds.filter(
            (selectedId) => selectedId !== id
          )
        } else {
          return [...prevSelectedRegisterIds, id]
        }
      })
    } else {
      setSelectedKpiIds((prevSelectedKpiIds) => {
        if (prevSelectedKpiIds.includes(id)) {
          return prevSelectedKpiIds.filter((selectedId) => selectedId !== id)
        } else {
          return [...prevSelectedKpiIds, id]
        }
      })
    }
  }

  const handleRangeChange = (interval: string): void => {
    const { today, defaultDataWindowUTC } = getUtcDateRange()
    const endDateLocal = dayjs()
    let startDateCus = ''
    let endDateCus = endDateLocal.format('YYYY-MM-DD HH:mm:ss')

    const getStartDate = (
      unit: dayjs.OpUnitType,
      subtractValue = 0,
      startOfUnit = true
    ): string => {
      const date =
        typeof subtractValue === 'number' &&
        !isNaN(subtractValue) &&
        subtractValue !== 0
          ? endDateLocal.subtract(subtractValue, unit as dayjs.ManipulateType)
          : endDateLocal
      return startOfUnit
        ? date.startOf(unit).utc().format('YYYY-MM-DD HH:mm:ss')
        : date.endOf(unit).utc().format('YYYY-MM-DD HH:mm:ss')
    }

    switch (interval) {
      case 'hourly':
        startDateCus = defaultDataWindowUTC
        endDateCus = today
        break
      case 'daily':
        startDateCus = getStartDate('day')
        endDateCus = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break

      case 'weekly':
        startDateCus = getStartDate('week')
        endDateCus = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break

      case 'monthly':
        startDateCus = getStartDate('month')
        endDateCus = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break
    }

    setRange(interval)

    const KPIObj = {
      deviceId: parentDeviceId,
      kpiDefinitionIds: selectedKpiIds,
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }

    const registerObj = {
      deviceId: parentDeviceId,
      cimCodeIds: selectedRegisterIds,
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }
    if (isGolive) {
      props.getAlertTrendKPIDataDeviceDashboardService(
        startDateCus,
        endDateCus,
        JSON.stringify(KPIObj),
        interval,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.getAlertTrendRegisterDataDeviceDashboardService(
        startDateCus,
        endDateCus,
        JSON.stringify(registerObj),
        interval,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
    } else if (startDate === '' && endDate === '') {
      props.getAlertTrendKPIDataDeviceDashboardService(
        startDateCus,
        endDateCus,
        JSON.stringify(KPIObj),
        interval,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.getAlertTrendRegisterDataDeviceDashboardService(
        startDateCus,
        endDateCus,
        JSON.stringify(registerObj),
        interval,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
    } else {
      props.getAlertTrendKPIDataDeviceDashboardService(
        startDate,
        endDate,
        JSON.stringify(KPIObj),
        interval,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.getAlertTrendRegisterDataDeviceDashboardService(
        startDate,
        endDate,
        JSON.stringify(registerObj),
        interval,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
    }
  }

  const handleHierarchyMenuApply = (): void => {
    setIsOpen(false)
    const utcDate = dayjs()
    const today = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    const defaultDataWindowUTC = utcDate.utc().subtract(DEFAULT_DATA_WINDOW_HOURS, 'hour')
    const KPIObj = {
      deviceId: parentDeviceId,
      kpiDefinitionIds: selectedKpiIds,
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }

    const registerObj = {
      deviceId: parentDeviceId,
      cimCodeIds: selectedRegisterIds,
      graphName: 'deviceAlertTrend',
      assetTypeId: parentDeviceTypeId
    }

    kpiObject.current = JSON.stringify(KPIObj)
    registerObject.current = JSON.stringify(registerObj)
    const rangeNew = disableHourly() ? 'daily' : range
    setRange(rangeNew)

    if (startDate !== '' && endDate !== '') {
      props.getAlertTrendKPIDataDeviceDashboardService(
        startDate,
        endDate,
        JSON.stringify(KPIObj),
        rangeNew,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.getAlertTrendRegisterDataDeviceDashboardService(
        startDate,
        endDate,
        JSON.stringify(registerObj),
        rangeNew,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
    } else {
      props.getAlertTrendKPIDataDeviceDashboardService(
        defaultDataWindowUTC.format('YYYY-MM-DD HH:mm:ss'),
        today,
        JSON.stringify(KPIObj),
        rangeNew,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.getAlertTrendRegisterDataDeviceDashboardService(
        defaultDataWindowUTC.format('YYYY-MM-DD HH:mm:ss'),
        today,
        JSON.stringify(registerObj),
        rangeNew,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
    }

    const selectedDefaultData = {
      widgetId: 'deviceAlertTrend',
      displayname: text,
      devices: [
        {
          deviceId: parentDeviceId,
          cimCodeIds: selectedRegisterIds,
          kpidefinitionIds: selectedKpiIds
        }
      ],
      assets: []
    }

    // update savedefault view redux state
    updateSaveDefaultObject(
      saveDefaultViewObject,
      selectedDefaultData,
      'deviceAlertTrend'
    )
  }

  const handleHierarchyMenuCancel = (): void => {
    setIsOpen(false)
  }

  const handleClearAll = (): void => {
    setSelectedRegisterIds([])
    setSelectedKpiIds([])
  }

  const [series, setSeries] = useState<any[]>([])
  const [chartOptions, setChartOptions] = React.useState({
    chart: {
      type: 'bar' as const,
      background: '#252525',
      height: 350,
      stacked: true,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom' as const,
            offsetX: -10,
            offsetY: 0
          }
        }
      }
    ],
    dataLabels: {
      enabled: false
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        dataLabels: {
          total: {
            enabled: false,
            style: {
              fontSize: '13px',
              fontWeight: 900
            }
          }
        }
      }
    },
    tooltip: {
      enabled: true,
      theme: 'dark',
      x: {
        show: false // Disable showing x-axis value or time
      },
      formatter: function (value: number) {
        return `${Math.round(value)}` // Only show the parameter value
      }
    },
    xaxis: {
      categories: [] as string[],
      title: {
        text: '',
        style: {
          color: '#D0D0D0',
          fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
          fontSize: '11px'
        }
      },
      labels: {
        show: true,
        rotate: -90,
        rotateAlways: false,
        style: {
          colors: '#D0D0D0',
          fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
          fontSize: '15px'
        }
      },
      axisBorder: {
        show: true,
        color: '#D0D0D0',
        height: 1,
        offsetX: 0,
        offsetY: 0
      },
      axisTicks: {
        show: false,
        borderType: 'solid',
        color: '#D0D0D0',
        height: 60,
        offsetX: 20,
        offsetY: 20
      },
      crosshairs: {
        show: true,
        width: 1,
        position: 'back',
        opacity: 0.9,
        stroke: {
          color: '#D0D0D0',
          width: 1,
          dashArray: 0
        }
      }
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      title: {
        text: 'Count',
        style: {
          color: '#D0D0D0',
          fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
          fontSize: '14px'
        }
      },
      axisTicks: {
        show: false
      },
      labels: {
        show: true,
        style: {
          colors: '#D0D0D0',
          fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
          fontSize: '15px'
        },
        formatter: function (value: number) {
          return Math.round(value).toString()
        }
      },
      tickAmount: 1
    },
    noData: {
      text: 'No Data Available',
      offsetX: 20,
      offsetY: -10,
      style: {
        color: '#F2F2F2',
        fontSize: '14px'
      }
    },
    annotations: {
      yaxis: []
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      fontSize: '14px',
      fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
      position: 'bottom' as const,
      itemMargin: {
        horizontal: 5,
        vertical: 10
      },
      labels: {
        colors: '#D0D0D0',
        fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
        fontSize: '14px',
        useSeriesColors: false
      },
      margin: {
        top: 15
      },
      onItemClick: {
        toggleDataSeries: true
      },
      onItemHover: {
        highlightDataSeries: true
      }
    },
    fill: {
      opacity: 1
    }
  })

  React.useEffect(() => {
    const formatReadingTime = (readingTime: any): string => {
      const date = moment.utc(readingTime).format('YYYY-MM-DD hh:mm:ss A')
      const dateObj = new Date(date)
      return range === 'hourly'
        ? dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : dateObj.toLocaleDateString()
    }

    const allZero = combinedData.every(
      (data: { paraMeterReading: Array<{ count: number }> }) =>
        data.paraMeterReading.every(
          (reading: { count: number }) => reading.count === 0
        )
    )

    const uniqueTimes =
      Array.isArray(combinedData) &&
      combinedData.length > 0 &&
      Array.isArray(combinedData[0].paraMeterReading)
        ? combinedData[0].paraMeterReading.map(
          (reading: { readingTime: string, count: any }) =>
            formatReadingTime(reading.readingTime)
        )
        : []

    const series: any = (Array.isArray(combinedData) ? combinedData : []).map(
      (alert) => {
        const data = alert.paraMeterReading.map(
          (reading: { readingTime: string, count: any }) => ({
            x: moment.utc(reading.readingTime).format('YYYY-MM-DD hh:mm:ss A'),
            y: reading.count,
            originalY: reading.count // Store original value
          })
        )
        return {
          name: alert.paraMeterName,
          data,
          visible: true // Ensure visibility is defined initially
        }
      }
    )

    setSeries(series)

    setChartOptions((prevOptions) => ({
      ...prevOptions,
      xaxis: {
        ...prevOptions.xaxis,
        categories: uniqueTimes
      },
      yaxis: {
        ...prevOptions.yaxis,
        min: allZero === true ? 0 : undefined,
        max: allZero === true ? 5 : undefined
      },
      annotations: {
        yaxis:
          allZero === true
            ? ([
                {
                  y: 0,
                  borderColor: '#252525',
                  label: {
                    borderColor: '#252525',
                    style: {
                      color: '#fff',
                      background: '#252525',
                      fontSize: '16px'
                    },
                    text: 'Selected Register or KPI has No Data',
                    offsetX: -300,
                    offsetY: -20
                  }
                }
              ] as any)
            : []
      }
    }))
  }, [combinedData])

  React.useEffect(() => {
    setAlertTrendParameter({
      timezone: userTimezone,
      status: 'Go live'
    })
    if (golive) {
      setGolive(false)
    }
  }, [golive])

  React.useEffect(() => {
    if (saveDefaultView) {
      setSaveDefaultView(false)
    }
  }, [saveDefaultView])

  const handleIconClick = (): void => {
    setOpenFilter(true)
    props.getAlertsNotificationDataByFilter(
      parentSiteId,
      parentAssetId,
      parentDeviceId,
      '',
      '',
      '',
      'desc'
    )
  }

  const handleSaveDefaulView = (): void => {
    if (saveDefaultViewObject !== null && saveDefaultViewObject !== undefined) {
      props.saveDefaultViewDataservice(parentDeviceId, saveDefaultViewObject)
    } else if (saveDefaultViewObject === undefined || saveDefaultViewObject === null) {
      props.saveDefaultViewDataservice(parentDeviceId, defaultView)
    }
  }

  useEffect(() => {
    if (!GetSaveDefaultWidgetStatus.isLoading) {
      dispatch(
        SaveDefaultViewObjectUpdateAction(
          GetSaveDefaultWidgetStatus.DefaultWidgetData
        )
      )
    }
  }, [GetSaveDefaultWidgetStatus])

  const handleStartDate = (val: any): void => {
    if (val !== null && endDateValue !== null) setSelectedDateRange(null)
    setAlertTrendParameter({
      timezone: userTimezone,
      status: 'Custom range'
    })
    setIsGolive(false)
    setCustomeDateSelection(true)
    const date = dayjs(val)
    const formattedDate = date.utc().format('YYYY-MM-DD HH:mm:ss')
    localStorage.setItem('startDate', formattedDate)
    setStartDate(formattedDate)
    setStartDateValue(val)
    setEndDate('')
    setEndDateValue(null)
    setGolive(false)
  }

  const handleEndDate = (val: any): void => {
    if (startDateValue !== null && val !== null) setSelectedDateRange(null)
    setAlertTrendParameter({
      timezone: userTimezone,
      status: 'Custom range'
    })
    setIsGolive(false)
    setCustomeDateSelection(true)
    const date = dayjs(val)
    const formattedDate = date.utc().format('YYYY-MM-DD HH:mm:ss')
    localStorage.setItem('endDate', formattedDate)
    setEndDate(formattedDate)
    setEndDateValue(val)
    setGolive(false)

    if (startDate) {
      const differenceInHours: number =
        (new Date(formattedDate).getTime() - new Date(startDate).getTime()) /
        (1000 * 60 * 60)
      const rangeNew = differenceInHours >= 25 ? 'daily' : range
      setRange(rangeNew)

      const KPIObj = {
        deviceId: parentDeviceId,
        kpiDefinitionIds: selectedKpiIds,
        graphName: 'deviceAlertTrend',
        assetTypeId: parentDeviceTypeId
      }

      const registerObj = {
        deviceId: parentDeviceId,
        cimCodeIds: selectedRegisterIds,
        graphName: 'deviceAlertTrend',
        assetTypeId: parentDeviceTypeId
      }

      props.getAlertTrendKPIDataDeviceDashboardService(
        startDate,
        formattedDate,
        JSON.stringify(KPIObj),
        rangeNew,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
      props.getAlertTrendRegisterDataDeviceDashboardService(
        startDate,
        formattedDate,
        JSON.stringify(registerObj),
        rangeNew,
        false,
        `${alertTrendParameter.timezone},${alertTrendParameter.status}`
      )
    }
  }

  const stopInterval = (): void => {
    setCustomeDateSelection(true)
  }

  const startInterval = (): void => {
    setCustomeDateSelection(false)
  }

  return (
    <>
      {oldParentDeviceId === parentDeviceId && (
        <>
      <Grid container className='device-dashboard-panel'>
        <Grid item xs={4} sm={5}>
          <img className='breadcrum-img' src={breadcrumimg} />
          <Breadcrumbs
            aria-label='breadcrumb'
            style={{
              marginTop: '25px',
              color: 'white',
              fontSize: '20px',
              fontFamily: 'Honeywell Sans Web'
            }}
          >
            <Typography
              sx={{ fontSize: '20px', fontFamily: 'Honeywell Sans Web' }}
              className='breadcrumb-title'
              variant='body1'
            >
              {parentSiteName}
            </Typography>
            <Link
              aria-label='navBreadcrumb1'
              className='devicemgmtli'
              data-testid='bc-link-1'
              underline='none'
              color='inherit'
              onClick={() => {
                navigate('/asset-dashboard', {
                  state: {
                    parentSiteId,
                    parentAssetId,
                    siteName: parentSiteName,
                    assetName: parentAssetName
                  }
                })
              }}
            >
              {parentAssetName}
            </Link>
            <Typography
              sx={{ fontSize: '20px', fontFamily: 'Honeywell Sans Web' }}
              className='breadcrumb-title'
              variant='body1'
            >
              {parentDeviceName}
            </Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item xs={8} sm={7}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'right',
              gap: '10px',
              paddingTop: '10px'
            }}
          >
            <MemorizedBookmark
              parentId={null}
              siteId={navigateState?.parentSiteId ?? null}
              assetId={navigateState?.parentAssetId ?? null}
              deviceId={navigateState?.deviceId ?? null}
            />
            {/* "Go Live" Button */}
            <Button onClick={handleGoLiveView} className='go-live-default'>
              {'Go Live'}
            </Button>
            <GenXDropdown
              placeholder={'Select Quick Range'}
              value={selectedDateRange}
              options={DataRangeOptions}
              onSelect={handleDataRangeChange}
              width={200}
            />
            {/* Date Range Picker */}
            <span className='date-selection'>
              <div className='C-datePicke'>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DateTimePicker']}>
                    <WhiteDatePicker
                      data-testid='date-picker'
                      disableFuture
                      value={startDateValue}
                      slotProps={{
                        textField: {
                          fullWidth: false,
                          style: { minWidth: 'auto' },
                          inputProps: { readOnly: true },
                          placeholder: 'Select start date'
                        }
                      }}
                      onChange={(val: any) => {
                        handleStartDate(val)
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className='C-datePicke'>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DateTimePicker']}>
                    <WhiteDatePicker
                      data-testid='date-picker'
                      disabled={startDateValue === null}
                      disableFuture
                      value={endDateValue}
                      minDate={dayjs(startDateValue)}
                      maxDate={dayjs(startDateValue).add(30, 'day')}
                      slotProps={{
                        textField: {
                          fullWidth: false,
                          style: { minWidth: 'auto' },
                          inputProps: { readOnly: true },
                          placeholder: 'Select end date'
                        }
                      }}
                      onAccept={(val: any) => {
                        handleEndDate(dayjs(val))
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
            </span>
            {operationPermissions.permissions
              .can_modify_tiq_intervalreadings
              ? (
              <Button
                onClick={handleSaveDefaulView}
                className='save-default'
                type='hollow'
                width={'165px'}
                sx={{ minWidth: '165px' }}
              >
                {'Save Default View'}
              </Button>
                )
              : null}
          </div>
          <MemoDeviceStatus parentDeviceId={parentDeviceId} />
        </Grid>
      </Grid>
      <Grid className='main-container' container style={{ marginTop: '20px' }}>
        <Grid item xs={8} style={{ paddingRight: '20px' }}>
          <Grid container style={{ width: '100%' }}>
            <Grid item xs={5}>
              <div className='box-wrapper'>
                <div className='header-top'>
                  <div>
                    <h6
                      style={{
                        marginTop: '-15px',
                        textAlign: 'left',
                        color: '#F0F0F0',
                        margin: 0
                      }}
                      className='heading title-box'
                    >
                      {'HEALTH SUMMARY'}
                    </h6>
                  </div>
                  <div className='right'>
                    <span className='device-notification'>
                      <img
                        onClick={handleIconClick}
                        style={{
                          width: '38px',
                          height: '38px',
                          cursor: 'pointer',
                          color: '#fff'
                        }}
                        src={notificationIcon}
                      ></img>
                    </span>
                  </div>
                </div>
                <div className='inner-wrapper' data-testid='healthSummaryCard'>
                  <MemoHealthSummaryCard
                    currentDeviceId={parentDeviceId}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={7} style={{ paddingLeft: '20px' }}>
              <DeviceStatusCard
                parentSiteId={parentSiteId}
                parentAssetId={parentAssetId}
                currentDeviceId={parentDeviceId}
                fetchAllParameters={fetchKPIandParamData}
                GoLive={golive}
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowGap={2}
            style={{ marginTop: '20px', width: '100%' }}
          >
            <Grid item xs={12} style={{ width: '100%' }}>
              <div className='box-wrapper' style={{ height: 'auto' }}>
                <Box
                  sx={{
                    backgroundColor: '#252525',
                    padding: '10px',
                    borderRadius: '8px',
                    flex: 1
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '20px'
                      }}
                    >
                      {isEditing
                        ? (
                        <TextField
                          value={text}
                          onChange={handleTextChange}
                          onBlur={handleBlur}
                          autoFocus
                          variant='outlined'
                          size='small'
                          sx={{ input: { color: '#f0f0f0' } }}
                        />
                          )
                        : (
                        <Typography
                          className='title-box'
                          sx={{ color: '#f0f0f0', textTransform: 'capitalize' }}
                        >
                          {text}
                        </Typography>
                          )}
                      <IconButton
                        onClick={handleEditClick}
                        size='small'
                        sx={{ color: '#f0f0f0' }}
                      >
                        <img src={EditIcon} />
                      </IconButton>
                    </div>
                    <div>
                      <IconButton onClick={handleOpenModalAlertTrend}>
                        <MoreVertIcon />
                      </IconButton>
                    </div>
                  </div>
                  <div>
                    <ButtonGroup
                      className='range-handle'
                      color='primary'
                      aria-label='outlined primary button group'
                      sx={{ mb: 2 }}
                    >
                      <CustomButton
                        variant={range === 'hourly' ? 'contained' : 'outlined'}
                        onClick={() => {
                          handleRangeChange('hourly')
                        }}
                        disabled={disableHourly()}
                      >
                        H
                      </CustomButton>
                      <CustomButton
                        variant={range === 'daily' ? 'contained' : 'outlined'}
                        onClick={() => {
                          handleRangeChange('daily')
                        }}
                      >
                        D
                      </CustomButton>
                      <CustomButton
                        variant={range === 'weekly' ? 'contained' : 'outlined'}
                        onClick={() => {
                          handleRangeChange('weekly')
                        }}
                      >
                        W
                      </CustomButton>
                      <CustomButton
                        variant={range === 'monthly' ? 'contained' : 'outlined'}
                        onClick={() => {
                          handleRangeChange('monthly')
                        }}
                      >
                        M
                      </CustomButton>
                    </ButtonGroup>
                    <div id='chart-container'>
                      {AlertRegisterData.isLoading || AlertKPIData.isLoading
                        ? (
                        <div
                          style={{
                            display: 'flex',
                            height: '350px',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                        >
                          <CircularProgress />
                        </div>
                          )
                        : (AlertRegisterData.httpStatus === 404 &&
                          AlertKPIData.httpStatus === 404) ||
                        AlertRegisterData.httpStatus === 500 ||
                        AlertKPIData.httpStatus === 500
                            ? (
                        <div
                          style={{
                            display: 'flex',
                            height: '350px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: '#f0f0f0'
                          }}
                        >
                          {' '}
                          <AuthError
                            className='alertTrendError'
                            errorMessage='NoDataPresentAlertTrend'
                          />
                        </div>
                              )
                            : (
                        <ApexCharts
                          options={chartOptions}
                          series={series}
                          type={chartOptions.chart.type}
                          height={350}
                        />
                              )}
                    </div>
                    <Dialog
                      open={isOpen}
                      onClose={handleCloseModal}
                      maxWidth='md'
                      fullWidth
                      sx={{
                        '& .MuiDialog-paper': {
                          width: '370px',
                          height: '500px',
                          backgroundColor: '#252525',
                          color: '#f0f0f0'
                        }
                      }}
                    >
                      <DialogTitle
                        style={{
                          textTransform: 'uppercase',
                          fontFamily: 'Honeywell Sans Web',
                          fontSize: '16px'
                        }}
                      >
                        Parameter Library
                      </DialogTitle>
                      <span
                        style={{ color: '#64C3FF', cursor: 'pointer' }}
                        onClick={handleClearAll}
                        data-testid='clear-menu-selection-btn'
                      >
                        <img
                          src={refresh}
                          height={20}
                          width={20}
                          style={{
                            marginLeft: '23px',
                            marginRight: '6px',
                            paddingTop: '3px'
                          }}
                        />
                        Clear all
                      </span>
                      <Divider
                        sx={{
                          backgroundColor: '#202020',
                          border: '1px solid #202020',
                          margin: '10px 0px'
                        }}
                      />
                      <DialogContent>
                        <div className='hierarchy-menu-content'>
                          {device !== null
                            ? (
                            <Box>
                              <Box
                                display='flex'
                                justifyContent='space-between'
                                alignItems='center'
                              >
                                <Typography
                                  style={{
                                    padding: '15px 0px',
                                    fontFamily: 'Honeywell Sans Web',
                                    fontSize: '16px'
                                  }}
                                >
                                  {' '}
                                  {device.name}{' '}
                                </Typography>
                              </Box>
                              <div style={{ marginLeft: '9%' }}>
                                {Array.isArray(device.registers) && device.registers?.map((register: any) => (
                                  <FormControlLabel
                                    key={register.cimCodeId}
                                    control={
                                      <Checkbox
                                        checked={selectedRegisterIds.includes(
                                          register.cimCodeId
                                        )}
                                        onChange={() => {
                                          handleChildCheckboxChange(
                                            register.cimCodeId,
                                            'register'
                                          )
                                        }}
                                        style={{
                                          color: '#64C3FF',
                                          fontFamily: 'Honeywell Sans Web',
                                          fontSize: '16px'
                                        }}
                                        className='hon-std-font'
                                      />
                                    }
                                    label={register.parameterName}
                                    onClick={handleCheckboxClick}
                                    data-testid='register-checkbox'
                                  />
                                ))}
                                {Array.isArray(device.kpis) && device.kpis
                                  .filter((kpi: any) => !kpi.isTotalizer)
                                  .map((kpi: any) => (
                                    <FormControlLabel
                                      key={kpi.kpiDefinitionId}
                                      control={
                                        <Checkbox
                                          checked={selectedKpiIds.includes(
                                            kpi.kpiDefinitionId
                                          )}
                                          onChange={() => {
                                            handleChildCheckboxChange(
                                              kpi.kpiDefinitionId,
                                              'kpi'
                                            )
                                          }}
                                          style={{
                                            color: '#64C3FF',
                                            fontFamily: 'Honeywell Sans Web',
                                            fontSize: '16px'
                                          }}
                                          className='hon-std-font'
                                        />
                                      }
                                      label={kpi.parameterName}
                                      onClick={handleCheckboxClick}
                                      data-testid='kpi-checkbox'
                                    />
                                  ))}
                              </div>
                            </Box>
                              )
                            : (
                            <div
                              className='authError'
                              data-testid='data-undefined-error'
                            >
                                                           <AuthError
                                className='paramterError'
                                errorMessage='NoDataPresent'
                              />
                            </div>
                              )}
                          {isModalOpen && (
                            <ModelPopup
                              buttonTypeNegative='hollow'
                              title={'Parameter Selection'}
                              LabelPositive={'Ok'}
                              onClickPositive={() => {
                                setIsModalOpen(false)
                              }}
                              onClose={() => {
                                setIsModalOpen(false)
                              }}
                            >
                              <p style={{ paddingTop: '1.2em' }}>
                                Please select only {maximumSelection} parameters
                              </p>
                            </ModelPopup>
                          )}
                        </div>
                      </DialogContent>
                      <Divider
                        sx={{
                          backgroundColor: '#202020',
                          border: '1px solid #202020',
                          margin: '10px 0px'
                        }}
                      />
                      <DialogActions
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                      >
                        <Button
                          onClick={handleHierarchyMenuCancel}
                          type='hollow'
                          data-testid='menu-cancel-btn'
                          aria-label='Cancel'
                        >
                          Cancel
                        </Button>
                        <Button
                          className='apply-btn'
                          onClick={handleHierarchyMenuApply}
                          data-testid='menu-apply-btn'
                          aria-label='Apply'
                        >
                          Apply
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </Box>
              </div>
            </Grid>
            <Grid item xs={12} style={{ width: '100%' }}>
              <div className='box-wrapper'>
                <FlameSignalGraph
                  deviceIdCurrent={parentDeviceId}
                  assetTypeID={parentDeviceTypeId}
                  parentAssetId={parentAssetId}
                  parentSiteId={parentSiteId}
                  defaultData={props.saveDefaultWidgetData.DefaultWidgetData}
                  saveDefaultViewCall={saveDefaultView}
                  startDate={startDate}
                  endDate={endDate}
                  Golive={golive}
                  stopInterval={stopInterval}
                  startInterval={startInterval}
                />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            style={{ marginTop: '20px', marginBottom: '20px', width: '100%' }}
          >
            <Grid item xs={12}>
              <div className='box-wrapper'>
                <FuelFlowGraph
                  deviceIdCurrent={parentDeviceId}
                  assetTypeID={parentDeviceTypeId}
                  parentSiteId={parentSiteId}
                  defaultData={props.saveDefaultWidgetData.DefaultWidgetData}
                  saveDefaultViewCall={saveDefaultView}
                  startDate={startDate}
                  endDate={endDate}
                  Golive={golive}
                  stopInterval={stopInterval}
                  parentAssetId={parentAssetId}
                  startInterval={startInterval}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
        <MemoParametersList
          parentSiteId={parentSiteId}
          parentDeviceId={parentDeviceId}
          parentDeviceTypeId={parentDeviceTypeId}
          refreshRightPanel={refreshRightPanel}
          goLive={golive} />
      </Grid>
      <Drawer
        anchor='right'
        open={openFilter}
        className='filter-drawer device-dashboard'
        onClose={() => {
          setOpenFilter(false)
        }}
      >
        <AlertNotification
          siteId={parentSiteId}
          assetId={parentAssetId}
          deviceId={parentDeviceId}
          setOpenFilter={setOpenFilter}
        />
      </Drawer>
      {
        props.SaveDefaultViewData.isLoading &&
        (<ModelPopup title={'Loading...'}>
          <div className='CircularprogressAmi'>
            <CircularProgress />
          </div>
        </ModelPopup>
        )}
      </>)}
    </>
  )
}
interface DispatchToProps {
  fetchParameterTree: () => void
  callGetHealthSummaryService: (
    siteId: string,
    asseIds: string,
    deviceIds: string
  ) => void
  getSaveDeafaultWidget: (siteID: string, parentAssetId: string, deviceIds: string) => void
  saveDefaultViewDataservice: (
    deviceId: string,
    requestParameter: SaveDefaultViewRequest
  ) => void
  getAlertsNotificationDataByFilter: (
    siteId: string,
    assetIds: string,
    deviceIds: string,
    severities: string,
    alertStatus: string,
    alarmLabelIds: string,
    sortOrder: string
  ) => void
  getDeviceStatusRegisterSummaryService: (
    siteId: string,
    deviceIds: string,
    cimCodeIDs: string,
    isDefault: boolean
  ) => void
  getDeviceStatusKPISummaryService: (
    siteId: string,
    deviceIds: string,
    kpiDefinitionIds: string,
    isDefault: boolean
  ) => void
  getDeviceStatusOnlineService: (deviced: string) => void
  getAlertTrendKPIDataDeviceDashboardService: (
    startDate: string,
    endDate: string,
    requestParameter: string,
    intervalGroup: string,
    isdefault: boolean,
    timeZone: string
  ) => void
  getAlertTrendRegisterDataDeviceDashboardService: (
    startDate: string,
    endDate: string,
    requestParameter: string,
    intervalGroup: string,
    isdefault: boolean,
    timeZone: string
  ) => void
  getOperationPermissions: (sub: string) => void
  fetchflameSignalData_NEW: (
    startDateTime: string,
    endDateTime: string,
    request: string,
    isDefault: boolean
  ) => void
  fetchflameKPISignalData: (
    startDateTime: string,
    endDateTime: string,
    request: string,
    isDefault: boolean
  ) => void
  fetchflowParamSignalData: (
    startDateTime: string,
    endDateTime: string,
    request: string,
    isDefault: boolean
  ) => void
  fetchflowKPISignalData: (
    startDateTime: string,
    endDateTime: string,
    request: string,
    isDefault: boolean
  ) => void
  getDeviceParameterService: (siteID: string, assetID: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchParameterTree: () => dispatch(fetchParameterTree()),
  callGetHealthSummaryService: (
    siteId: string,
    asseIds: string,
    deviceIds: string
  ) => dispatch(getHealthSummaryService(siteId, asseIds, deviceIds)),
  getSaveDeafaultWidget: (siteID: string, parentAssetId: string, deviceIds: string) =>
    dispatch(getSaveDeafaultWidget(siteID, parentAssetId, deviceIds)),
  saveDefaultViewDataservice: (
    deviceId: string,
    requestParameter: SaveDefaultViewRequest
  ) => dispatch(saveDefaultViewDataservice(deviceId, requestParameter)),
  getAlertsNotificationDataByFilter: (
    siteId: string,
    assetIds: string,
    deviceIds: string,
    severities: string,
    alertStatus: string,
    alarmLabelIds: string,
    sortOrder: string
  ) =>
    dispatch(
      getAlertsNotificationDataByFilter(
        siteId,
        assetIds,
        deviceIds,
        severities,
        alertStatus,
        alarmLabelIds,
        sortOrder
      )
    ),
  getDeviceStatusRegisterSummaryService: (
    siteId: string,
    deviceIds: string,
    cimCodeIDs: string,
    isDefault: boolean
  ) =>
    dispatch(
      getDeviceStatusRegisterSummaryService(
        siteId,
        deviceIds,
        cimCodeIDs,
        isDefault
      )
    ),
  getDeviceStatusKPISummaryService: (
    siteId: string,
    deviceIds: string,
    kpiDefinitionIds: string,
    isDefault: boolean
  ) =>
    dispatch(
      getDeviceStatusKPISummaryService(
        siteId,
        deviceIds,
        kpiDefinitionIds,
        isDefault
      )
    ),
  getDeviceStatusOnlineService: (deviced: string) =>
    dispatch(getDeviceStatusOnlineService(deviced)),
  getAlertTrendKPIDataDeviceDashboardService: (
    startDate: string,
    endDate: string,
    requestParameter: string,
    intervalGroup: string,
    isdefault: boolean,
    timeZone: string
  ) =>
    dispatch(
      getAlertTrendKPIDataDeviceDashboardService(
        startDate,
        endDate,
        requestParameter,
        intervalGroup,
        isdefault,
        timeZone
      )
    ),
  getAlertTrendRegisterDataDeviceDashboardService: (
    startDate: string,
    endDate: string,
    requestParameter: string,
    intervalGroup: string,
    isdefault: boolean,
    timeZone: string
  ) =>
    dispatch(
      getAlertTrendRegisterDataDeviceDashboardService(
        startDate,
        endDate,
        requestParameter,
        intervalGroup,
        isdefault,
        timeZone
      )
    ),
  getOperationPermissions: (sub: string) =>
    dispatch(getOperationPermissions(sub)),
  fetchflameSignalData_NEW: (
    startDateTime: string,
    endDateTime: string,
    request: string,
    isDefault: boolean
  ) =>
    dispatch(
      fetchflameSignalDataNEWONE(startDateTime, endDateTime, request, isDefault)
    ),
  fetchflameKPISignalData: (
    startDateTime: string,
    endDateTime: string,
    request: string,
    isDefault: boolean
  ) =>
    dispatch(
      fetchflameKPISignalData(startDateTime, endDateTime, request, isDefault)
    ),
  fetchflowParamSignalData: (
    startDateTime: string,
    endDateTime: string,
    request: string,
    isDefault: boolean
  ) =>
    dispatch(
      fetchflowParamSignalData(startDateTime, endDateTime, request, isDefault)
    ),
  fetchflowKPISignalData: (
    startDateTime: string,
    endDateTime: string,
    request: string,
    isDefault: boolean
  ) =>
    dispatch(
      fetchflowKPISignalData(startDateTime, endDateTime, request, isDefault)
    ),
  getDeviceParameterService: (siteID: string, assetID: string) =>
    dispatch(fetchParameterConfiguration(siteID, assetID))
})

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface StateToProps {
  parameterTree: ParameterTreeState
  saveDefaultWidgetData: GetDefaultWidgetDataState
  SaveDefaultViewData: SaveDefaultViewDataState
  menuInfo: MenuInfoState
  alertTrendKPIDeviceDashboard: AlertTrendKPIDeviceDataState
  alertTrendRegisterDeviceDashboard: AlertTrendRegisterDataDeviceState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  parameterTree: state.parameterTree,
  saveDefaultWidgetData: state.saveDefaultWidgetData,
  SaveDefaultViewData: state.SaveDefaultViewData,
  menuInfo: state.menuInfoState,
  alertTrendKPIDeviceDashboard: state.alertTrendKPIDeviceDashboard,
  alertTrendRegisterDeviceDashboard: state.alertTrendRegisterDeviceDashboard
})
const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(deviceDashboardMain)
